import { dispatch } from "hf-rt";

const initialState = {
  isEmailEmpty: false,
  isEmailCheckFailed: false
};

export default {
  name: "validate",
  actions: {
    setEmailEmpty: () => dispatch({ type: "SET_EMAIL_EMPTY" }),
    setEmailCheckFailed: () => dispatch({ type: "SET_EMAIL_CHECK_FAILED" }),
    setEmailValidateInit: () => dispatch({ type: "SET_EMAIL_VALIDATE_INIT" })
  },
  reducers: function(state = initialState, action) {
    switch (action.type) {
      case "SET_EMAIL_EMPTY":
        return { ...state, isEmailEmpty: true };
      case "SET_EMAIL_CHECK_FAILED":
        return { ...state, isEmailCheckFailed: true };
      case "SET_EMAIL_VALIDATE_INIT":
        return { ...state, isEmailEmpty: false, isEmailCheckFailed: false };
      default:
        return state;
    }
  }
};
